const brokerAccountView_ColumnDefs = [
  { headerName: 'Account Code', field: 'accountCode', width: 160 },
  { headerName: 'Account Desc', field: 'accountDesc', width: 220 },
  { headerName: 'Broker', field: 'brokerCode', width: 150 },
  {
    headerName: 'Fund',
    field: 'fundCode',
    width: 100,
  },
  {
    headerName: 'AccountType',
    field: 'accountType',
    width: 120,
  },
  { headerName: 'PnlEngineType', field: 'pnlEngineType', width: 120 },
  {
    headerName: 'HandInst',
    field: 'handInst',
    width: 140,
  },
  {
    headerName: 'Market',
    field: 'market',
    width: 180,
  },
  {
    headerName: 'IsActive',
    field: 'isActive',
    width: 80,
  },
  { headerName: 'LastModifiedBy', field: 'lastModifiedBy', width: 120 },
  { headerName: 'LastModifiedOn', field: 'lastModifiedOn', width: 160 },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      fn: () => {},
    },
  },
]

export default brokerAccountView_ColumnDefs
